import { connect } from 'react-redux';
import { selectActiveVenueId, selectUserIsAuthenticated, selectUserIsLoaded } from 'selectors/general';

import NotFound from './NotFound';

const mapStateToProps = state => ({
  activeVenueId: selectActiveVenueId(state),
  isAuthenticated: selectUserIsAuthenticated(state),
  isLoaded: selectUserIsLoaded(state),
});

export default connect(mapStateToProps)(NotFound);
